export default class Promocode {
    constructor(
        reward,
        quantity,
        productId,
        rewardType,
        isDisposable,
        expiresIn
    ) {
        this.reward = reward;
        this.quantity = quantity;
        this.productId = productId;
        this.rewardType = rewardType;
        this.isDisposable = isDisposable;
        this.expiresIn = expiresIn;
    }
}
